import {RateAgreementExport} from "./hooks/useRateAgreementExport";

export async function downloadRateAgreementExport(
    exportDetails: RateAgreementExport
): Promise<void> {
    const expiry = exportDetails.expiresAt.utcDateTime;
    if (!(expiry instanceof Date) || !Number.isFinite(expiry.getTime())) {
        throw new Error(
            "The export expiry could not be read. Please try the export again."
        );
    }
    if (expiry.getTime() <= Date.now()) {
        throw new Error(
            "This export link has expired. Start a new export to download the file."
        );
    }

    const response = await fetch(exportDetails.downloadUrl, {
        method: "GET"
    });

    if (!response.ok) {
        if (response.status === 410) {
            throw new Error(
                "This export link has expired. Start a new export to download the file."
            );
        }
        if (response.status === 401 || response.status === 403) {
            if (expiry.getTime() <= Date.now()) {
                throw new Error(
                    "This export link has expired. Start a new export to download the file."
                );
            }
            throw new Error(
                "Your Rates access could not be verified. Check your access and try again."
            );
        }
        throw new Error(
            "The rates file could not be downloaded. Please try the export again."
        );
    }

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = exportDetails.fileName;
    anchor.style.display = "none";
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
}
